import { useApiContext } from 'react-easyrocket';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { useModalContext } from './useModalContext';

const SHOW_DEPOSIT_SS_KEY = 'showDepositModal';

/** Открывает модальное окно депозита 1 раз в начале сессии.
 * Также открывает окно депозита после логина или регистрации 1 раз
 * в сессию
 */
export function useOpenDepositOnSessionStart() {
  const { isAuthenticated } = useApiContext();
  const prevIsAuthenticated = useRef(false);
  const { openModal, openedModalName, closeModal } = useModalContext();
  const { pathname } = useLocation();
  const excludeRoutes =
    /deposit-(success|failure|return)/.test(pathname) || pathname.includes('info_pages');

  useEffect(() => {
    if (!prevIsAuthenticated.current && isAuthenticated && !excludeRoutes) {
      const showDepositFromSession = getShowDeposit();
      if (showDepositFromSession) {
        openModal('DEPOSIT');
        setDepositModalAsShown();
      }
    }

    if (prevIsAuthenticated.current && !isAuthenticated) {
      resetDepositModalShow();
    }

    prevIsAuthenticated.current = isAuthenticated;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  /**
   * Закрывает модальное окно депозита, если оно по каким-то причинам успело открыться
   * но сессия истекла или isAuthenticated стало false. Иначе бывает проблема, при которой
   * депозит висит бесконечно без загруженных методов оплаты
   */
  useEffect(() => {
    if (!isAuthenticated && openedModalName === 'DEPOSIT') {
      closeModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, openedModalName]);
}

/** Отмечает что окно депозита было уже открыто. Также можно использовать, если нужно запретить автооткрывание модалки депозита раз в сессию */
function setDepositModalAsShown() {
  sessionStorage.setItem(SHOW_DEPOSIT_SS_KEY, 'false');
}
/** Отмечает, что окно депозита нужно открыть, когда пользователь будет залогинен. Также можно использовать если нужно разрешить модалке депозита открыться как только пользователь будет залогинен */
function resetDepositModalShow() {
  sessionStorage.setItem(SHOW_DEPOSIT_SS_KEY, 'true');
}
/** Функция отображающее текущее состояние запрещено или разрешено открывать модалку депозита раз в сессию */
function getShowDeposit() {
  const showDepositFromSession = sessionStorage.getItem(SHOW_DEPOSIT_SS_KEY);
  return showDepositFromSession === null ? true : JSON.parse(showDepositFromSession);
}
